import { Component } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';


interface IExportStatementByDateModalContext {
  account: any;
}
@Component({
  selector: 'app-export-statement-by-date-modal',
  templateUrl: './export-statement-by-date-modal.component.html',
  styleUrls: ['./export-statement-by-date-modal.component.scss'],
})
export class ExportStatementByDateModalComponent {
  pending = false;
  error: any;
  success: any;
  startDate: any;
  endDate: any;
  filter = new AppFilter({
    sidx: 'dateCreated',
    sord: 'asc',
    _search: false,
  });
  searchFilter = {
    groupOp: 'and',
    rules: [
      {
        field: 'dateCreated',
        op: 'ge',
        data: '',
      },
      {
        field: 'dateCreated',
        op: 'lt',
        data: '',
      },
    ],
  };

  constructor(
    public modal: SuiModal<IExportStatementByDateModalContext, void, void>,
    private walletService: EwalletService,
  ) {}

  capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  submit() {
    this.pending = true;
    this.filter._search = true;
    this.searchFilter.rules[0].data = new Date(this.startDate).toISOString().slice(0, 19);
    this.searchFilter.rules[1].data = new Date(this.endDate).toISOString().slice(0, 19);
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.walletService.exportEWalletTransactions({
      nccId: this.modal.context.account.nccId, 
      currencyId: this.modal.context.account.currencyId, 
      params: this.filter,
    }).subscribe(
      (res) => {
        console.log({res});
        const formatDate = (date) => {
          return new Date(date).toLocaleDateString('en-Gb', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })
        }
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(res);
        downloadLink.download = `EWallet ${this.capitalize(this.modal.context.account.currencyShortName)} Statement ${formatDate(this.startDate)}-${formatDate(this.endDate)}.xlsx`;
        downloadLink.click();
        this.pending = false;
        this.modal.approve(null)
      },
      (error) => {
        console.log({error})
        this.error = error;
        this.pending = false;
      }
    )
  }
}

export class ExportStatementByDateModal extends ComponentModalConfig<
  IExportStatementByDateModalContext,
  void,
  void
> {
  constructor(
    account: any,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(ExportStatementByDateModalComponent, {account});

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
